import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiRequest } from '@/shared/api'

// Открыть/скрыть документ заказчику. Инвалидация — весь namespace документов.
export function useSetVisibility(documentId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (visible: boolean) =>
      apiRequest({
        method: 'PATCH',
        url: `/documents/${documentId}/visibility`,
        body: { visible },
      }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['document'] })
    },
  })
}
